<template>
  <v-dialog v-model="hideShowDialog" scrollable max-width="300px">
    <template #activator="{ on }">
      <ButtonTooltip
        :tooltip-props="{ 'nudge-bottom': 8 }"
        tooltip-text="Add or Remove Columns"
        icon-name="fa-columns"
        small
        color="primary"
        v-on="on"
      />
    </template>
    <v-card>
      <v-card-title>Show/Hide Columns</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pt-3" style="max-height: 300px">
        <template v-for="(item, i) in tableFields">
          <v-checkbox
            v-if="item.text !== ''"
            :key="`item-${i}`"
            v-model="selectedHeaders"
            :value="item"
            :label="item.text"
            class="mt-0"
            hide-details
          ></v-checkbox>
        </template>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeHideShow">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapStores } from "pinia"
import { useReportStore } from "@/stores/report"
import ButtonTooltip from "@evercam/shared/components/ButtonTooltip.vue"

export default {
  components: { ButtonTooltip },
  props: {
    tableFields: {
      type: Array,
      required: true,
    },
    selectedHeadersList: {
      type: Array,
      default: () => [],
    },
  },
  data: () => {
    return {
      hideShowDialog: false,
    }
  },
  computed: {
    ...mapStores(useReportStore),
    selectedHeaders: {
      get() {
        return this.selectedHeadersList.length > 0
          ? this.selectedHeadersList
          : this.reportStore.selectedHeaders
      },
      set(value) {
        if (this.selectedHeadersList.length > 0) {
          this.$emit("update-selectedHeaders", value)
        } else {
          this.reportStore.selectedHeaders = value
        }
      },
    },
  },
  methods: {
    closeHideShow() {
      this.hideShowDialog = false
    },
  },
}
</script>
